const windowOpen = {
    open: function (url) {
        let newA = document.createElement('a');
        newA.target = '_blank';
        newA.href = url;
        document.body.appendChild(newA);
        newA.click();
        document.body.removeChild(newA);
    },
    openSelf: function (url) {
        let newA = document.createElement('a');
        newA.target = '_self';
        newA.href = url;
        document.body.appendChild(newA);
        newA.click();
        document.body.removeChild(newA);
    },
    download: function (data, fileName) {
        if (!data) {
            return;
        }
        let blob = new Blob([data], {
            type: 'application/vnd.ms-excel'
        });
        let url = window.URL.createObjectURL(blob);
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(link.href);
        }
    }
};

export default windowOpen;
